module.exports = __webpack_public_path__ + "img/delete.88bc0fd2.svg";